module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addActivityData
    }
  }, [_vm._v("添加活动")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "活动名称"
    },
    model: {
      value: (_vm.params.name),
      callback: function($$v) {
        _vm.$set(_vm.params, "name", $$v)
      },
      expression: "params.name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.dataSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "value-format": "yyyy/MM/dd",
      "placeholder": "选择日期范围"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.create_time),
      callback: function($$v) {
        _vm.create_time = $$v
      },
      expression: "create_time"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "全部",
      "name": "all"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "进行中",
      "name": "processing"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "待开始",
      "name": "waiting"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "自动已结束",
      "name": "over"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "手动已终止",
      "name": "close"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.activityLists,
      "height": _vm.wheight - 220
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "活动描述"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.description))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "提货时间"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.delivery_date))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "创建时间"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.created_date))])])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "activity_id",
      "label": "活动ID",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "活动名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.activity_name)), _c('br')]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "activity_start_date",
      "label": "开始时间",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "activity_end_date",
      "label": "结束时间",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "community",
      "label": "社区限制",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.community == 'all') ? _c('span', [_vm._v("\n          全部社区\n        ")]) : _c('span', [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.viewCommunityList(scope.row.community)
            }
          }
        }, [_vm._v("查看社区")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "150",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.viewGoodsList(scope.row.activity_id)
            }
          }
        }, [_vm._v("查看商品")]), _vm._v(" "), (scope.row.status == 'processing' || scope.row.status == 'waiting') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.updateStatusCommunityAction('close', scope.row)
            }
          }
        }, [_vm._v("终止")]) : _vm._e(), _vm._v(" "), (scope.row.status == 'waiting' && scope.row.is_maturity) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.updateStatusCommunityAction('start', scope.row)
            }
          }
        }, [_vm._v("开启")]) : _vm._e(), _vm._v(" "), (scope.row.status == 'processing' || scope.row.status == 'waiting') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editCommunityAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.addSimilarActvity(scope.row.activity_id)
            }
          }
        }, [_vm._v("添加相似")]), _vm._v(" "), (scope.row.status == 'over' || scope.row.status == 'close') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.exportActivityItemList(scope.row.activity_id)
            }
          }
        }, [_vm._v("下载备货单")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next, total",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "社区信息列表",
      "visible": _vm.communityVisible,
      "before-close": _vm.handleCancel,
      "width": "70%"
    },
    on: {
      "update:visible": function($event) {
        _vm.communityVisible = $event
      }
    }
  }, [
    [_c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      attrs: {
        "data": _vm.communityLists
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "community_id",
        "label": "ID",
        "width": "50"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "community_name",
        "label": "名称"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "leader_name",
        "label": "团长姓名",
        "width": "110"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "leader_mobile",
        "label": "团长手机",
        "width": "120"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "address",
        "label": "提货地址"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "created_date",
        "label": "入驻时间",
        "width": "100"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "status",
        "label": "状态",
        "width": "80"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.status === 'open') ? _c('span', [_vm._v("营业")]) : _vm._e(), _vm._v(" "), (scope.row.status === 'close') ? _c('span', [_vm._v("暂停")]) : _vm._e(), _vm._v(" "), (scope.row.status === 'loading') ? _c('span', [_vm._v("待审核")]) : _vm._e(), _vm._v(" "), (scope.row.status === 'refuse') ? _c('span', [_vm._v("拒绝申请")]) : _vm._e()]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "pass_date",
        "label": "通过时间",
        "width": "100"
      }
    })], 1)]
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "活动商品列表",
      "visible": _vm.goodsVisible,
      "before-close": _vm.handleCancel,
      "width": "70%"
    },
    on: {
      "update:visible": function($event) {
        _vm.goodsVisible = $event
      }
    }
  }, [
    [_c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      attrs: {
        "data": _vm.goodsList
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "item_id",
        "label": "id",
        "width": "60"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "item_name",
        "label": "商品名称"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "activity_price",
        "label": "活动价",
        "width": "70"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n           " + _vm._s(_vm.cursymbol) + _vm._s(scope.row.activity_price) + "\n           ")]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "vip_price",
        "label": "vip价",
        "width": "70"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n         " + _vm._s(_vm.cursymbol) + _vm._s(scope.row.vip_price) + "\n       ")]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "svip_price",
        "label": "svip价",
        "width": "70"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n         " + _vm._s(_vm.cursymbol) + _vm._s(scope.row.svip_price) + "\n       ")]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "activity_store",
        "label": "库存",
        "width": "60"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "points",
        "label": "积分",
        "width": "60"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "sort",
        "label": "排序",
        "width": "60"
      }
    })], 1), _vm._v(" "), (_vm.goodsCount > _vm.goodsPageSize) ? _c('div', {
      staticClass: "content-center content-top-padded"
    }, [_c('el-pagination', {
      attrs: {
        "layout": "prev, pager, next",
        "current-page": _vm.goodsPage,
        "total": _vm.goodsCount,
        "page-size": _vm.goodsPageSize
      },
      on: {
        "current-change": _vm.handleGoodsCurrentChange,
        "update:currentPage": function($event) {
          _vm.goodsPage = $event
        },
        "update:current-page": function($event) {
          _vm.goodsPage = $event
        }
      }
    })], 1) : _vm._e()]
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a1d7aaea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1d7aaea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/community/activity/list.vue
// module id = 2894
// module chunks = 0